import * as documentationActions from '../actions/documentation'
import * as h2Api from '../h2Api'

const initialState = {
  modalOpen: false,
  selectedSection: null,
  collection: {}
}
const documentation = (state = initialState, action) => {
  switch (action.type) {
    case documentationActions.SET_SELECTED_SECTION:
      return {
        ...state,
        selectedSection: action.selectedSection
      }
    case documentationActions.CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false,
        selectedSection: null
      }
    case documentationActions.OPEN_MODAL:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          modalOpen: true,
          selectedSection: null,
          collection: action.restCall.result
        }
      }

      return state
    default:
      return state
  }
}

export default documentation
